<template>
  <div class="sci-page-wrapper" style="font-family: 'Inter', sans-serif; background: #f4f6f9; min-height: 100vh;">
    <div class="max-w-7xl mx-auto px-4 py-8 space-y-6">
      
      <!-- HEADER -->
      <div class="sci-page-header pb-2">
        <h1 class="text-3xl font-black text-slate-800 uppercase tracking-tight">Frentistas</h1>
        <p class="text-sm text-slate-500 font-medium mt-1">Gestão de colaboradores vinculados aos fornecedores</p>
      </div>

      <!-- GRID DE FRENTISTAS -->
      <section class="bg-white rounded-xl border border-slate-200 overflow-hidden shadow-sm">
          <div style="background-color: #333333; display: flex; align-items: center; padding: 10px 20px; width: 100%; box-sizing: border-box;">

              <!-- TÍTULO -->
              <div style="display: flex; align-items: center; gap: 8px; flex-shrink: 0;">
                <v-icon color="orange" small>mdi-account-group</v-icon>
                <span style="color: white; font-weight: 700; font-size: 11px; text-transform: uppercase; letter-spacing: 0.1em;">FRENTISTAS</span>
              </div>

              <!-- AÇÕES FIXADAS À DIREITA -->
              <div style="margin-left: auto; display: flex; align-items: center; gap: 12px; flex-shrink: 0;">

                <!-- BOTÃO NOVO -->
                <button
                  v-if="isAdmin"
                  @click="$router.push('/attendants-manager/create')"
                  style="height: 32px; width: auto; white-space: nowrap; flex-shrink: 0; background-color: #f37021; color: white; display: inline-flex; align-items: center; gap: 6px; border-radius: 8px; padding: 0 14px; font-size: 10px; font-weight: 700; letter-spacing: 0.08em; text-transform: uppercase; border: none; cursor: pointer; transition: background-color 0.2s;"
                  onmouseover="this.style.backgroundColor='#e0601a'"
                  onmouseout="this.style.backgroundColor='#f37021'"
                >
                  <v-icon color="white" x-small>mdi-plus</v-icon>
                  NOVO
                </button>

                <!-- LUPA -->
                <v-icon
                  color="white"
                  size="18"
                  style="opacity: 0.7; cursor: pointer;"
                  @click="showSearch = !showSearch; $nextTick(() => { if (showSearch) { const el = window.document.getElementById('attendant-search-input'); if(el) el.focus(); } })"
                >
                  {{ showSearch ? 'mdi-close' : 'mdi-magnify' }}
                </v-icon>

              </div>
          </div>

          <!-- BARRA DE PESQUISA EXPANSÍVEL -->
          <div v-if="showSearch" class="px-5 py-2 flex items-center gap-2" style="background-color: #3d3d3d;">
            <v-icon color="white" size="14" class="opacity-50">mdi-magnify</v-icon>
            <input
              v-model="search"
              type="text"
              placeholder="PESQUISAR POR NOME, CPF, E-MAIL..."
              class="bg-transparent text-white w-full text-[10px] font-bold tracking-widest uppercase outline-none placeholder:text-white/30"
              @keyup.esc="showSearch = false"
              id="attendant-search-input"
            />
          </div>

          <div class="overflow-x-auto">
             <v-data-table
                :headers="headers"
                :items="data"
                :search="search"
                :page.sync="page"
                :items-per-page="itemsPerPage"
                @page-count="pageCount = $event"
                :loading="loader"
                loading-text="CARREGANDO..."
                class="custom-table"
                hide-default-footer
              >
                <template v-slot:item.attendant_name="{ item }">
                  <div class="flex items-center gap-3 py-2">
                    <v-avatar size="32" class="border border-slate-100 bg-slate-50">
                      <img :src="item.attendant_photo ? 'https://api.sigfrotagov.com.br/uploads/' + item.attendant_photo : require('@/assets/no-image.jpg')" alt="Foto">
                    </v-avatar>
                    <div>
                      <span class="text-sm font-bold text-slate-700 block uppercase">{{ item.attendant_name }}</span>
                    </div>
                  </div>
                </template>

                <template v-slot:item.attendant_cpf="{ item }">
                  <span class="text-xs text-slate-500 font-mono">{{ item.attendant_cpf }}</span>
                </template>

                <template v-slot:item.attendant_tel="{ item }">
                  <span class="text-xs text-slate-500">{{ item.attendant_tel || item.attendant_cel }}</span>
                </template>

                <template v-slot:item.attendant_mail="{ item }">
                  <span class="text-xs text-slate-500 lowercase">{{ item.attendant_mail }}</span>
                </template>

                <template v-slot:item.action="{ item }">
                  <div class="flex justify-end gap-2 px-4">
                    <button 
                      @click="$router.push(`/attendants-manager/edit/${item.attendant_id}`)"
                      class="p-2 hover:bg-orange-50 text-orange-600 rounded-lg transition-colors"
                    >
                      <v-icon small color="orange">mdi-pencil</v-icon>
                    </button>
                    <button 
                      @click="deleteItem(item.attendant_id)"
                      class="p-2 hover:bg-red-50 text-red-600 rounded-lg transition-colors"
                    >
                      <v-icon small color="red">mdi-delete</v-icon>
                    </button>
                  </div>
                </template>

                <template v-slot:no-data>
                  <div class="py-12 flex flex-col items-center justify-center text-slate-400">
                    <v-icon size="48" color="slate-100">mdi-database-off</v-icon>
                    <p class="mt-2 text-[10px] font-bold uppercase tracking-widest">Nenhum frentista encontrado</p>
                  </div>
                </template>
              </v-data-table>

              <!-- Custom Pagination Footer -->
              <div class="bg-slate-50 px-6 py-6 border-t border-slate-100 flex flex-col items-center justify-center gap-4 text-[10px] text-slate-400 font-bold uppercase tracking-widest">
                  <span>Exibindo {{ paginationStart }} de {{ data.length }} registros</span>
                  
                  <div class="flex gap-2">
                      <button 
                        @click="page > 1 ? page-- : null" 
                        :disabled="page === 1"
                        class="px-4 py-2 bg-white border border-slate-200 rounded-lg hover:bg-slate-100 disabled:opacity-50 disabled:cursor-not-allowed transition-all"
                      >
                        Anterior
                      </button>
                      
                      <button 
                        v-for="p in visiblePages" 
                        :key="p"
                        @click="page = p"
                        :class="p === page ? 'bg-slate-700 text-white border-slate-700 shadow-sm' : 'bg-white border-slate-200 hover:bg-slate-100'"
                        class="w-8 h-8 border rounded-lg transition-all flex items-center justify-center"
                      >
                        {{ p }}
                      </button>

                      <button 
                        @click="page < pageCount ? page++ : null" 
                        :disabled="page === pageCount"
                        class="px-4 py-2 bg-white border border-slate-200 rounded-lg hover:bg-slate-100 disabled:opacity-50 disabled:cursor-not-allowed transition-all"
                      >
                        Próximo
                      </button>
                  </div>
              </div>
          </div>
      </section>

      <!-- Snackbar -->
      <v-snackbar
        v-model="snack.show"
        :color="snack.color"
        timeout="3000"
        top
        elevation="24"
        class="custom-snack"
      >
        <div class="flex items-center gap-3">
          <v-icon color="white" small>{{ snack.color === 'success' ? 'mdi-check-circle' : 'mdi-alert-circle' }}</v-icon>
          <span class="text-xs font-bold uppercase tracking-widest">{{ snack.message }}</span>
        </div>
      </v-snackbar>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      search: "",
      showSearch: false,
      loader: true,
      data: [],
      page: 1,
      pageCount: 0,
      itemsPerPage: 10,
      snack: {
        show: false,
        message: "",
        color: ""
      },
      headers: [
        { text: "Frentista / Colaborador", value: "attendant_name" },
        { text: "Documento (CPF)", value: "attendant_cpf" },
        { text: "Telefone de Contato", value: "attendant_tel" },
        { text: "E-Mail", value: "attendant_mail" },
        { text: "Ações", align: "right", value: "action", sortable: false }
      ]
    };
  },
  computed: {
    isAdmin() {
      return this.$store.getters.getUserData.group_id === 1;
    },
    paginationStart() {
      return (this.page - 1) * this.itemsPerPage + 1;
    },
    visiblePages() {
      const pages = [];
      const totalVisible = 5;
      let start = Math.max(1, this.page - Math.floor(totalVisible / 2));
      let end = Math.min(this.pageCount, start + totalVisible - 1);
      if (end - start + 1 < totalVisible) start = Math.max(1, end - totalVisible + 1);
      for (let i = start; i <= end; i++) pages.push(i);
      return pages;
    }
  },
  created() {
    this.initialize();
  },
  methods: {
    initialize() {
      this.loader = true;
      this.$store.dispatch("setLoader", this.loader);
      this.$http
        .get("/attendants")
        .then(r => {
          this.data = r.data;
          this.loader = false;
          this.$store.dispatch("setLoader", false);
        })
        .catch(e => {
          this.loader = false;
          this.snack.show = true;
          this.snack.message = e.message;
          this.snack.color = "error";
          this.$store.dispatch("setLoader", false);
        });
    },
    deleteItem(id) {
      if (confirm("Deseja realmente excluir este frentista? Esta ação não pode ser desfeita.")) {
        this.$store.dispatch("setLoader", true);
        this.$http
          .delete(`/attendants/${id}`)
          .then(r => {
            this.snack.show = true;
            this.snack.message = r.data.result;
            this.snack.color = "success";
            this.initialize();
          })
          .catch(e => {
            this.snack.show = true;
            this.snack.message = e.message;
            this.snack.color = "error";
            this.$store.dispatch("setLoader", false);
          });
      }
    }
  }
};
</script>

<style scoped>
.custom-table ::v-deep table { background-color: transparent !important; border-collapse: separate; border-spacing: 0; }
.custom-table ::v-deep th { 
  color: #94a3b8 !important; 
  font-weight: 700 !important; 
  text-transform: uppercase !important; 
  font-size: 10px !important; 
  letter-spacing: 0.05em !important;
  background-color: #f8fafc !important;
  border-bottom: 1px solid #e2e8f0 !important;
  height: 48px !important;
}
.custom-table ::v-deep td { 
  border-bottom: 1px solid #f1f5f9 !important;
  color: #334155 !important;
  font-size: 13px !important;
}
.custom-snack >>> .v-snack__wrapper {
  border-radius: 10px !important;
}
</style>